import client from './client';

const User = {
  getUserData() {
    return client.get('/user');
  },
};

export default User;
